module.exports = __webpack_public_path__ + "media/assets/images/app/Landing/WhyUs__carousel__1-8c0b0708e7379e5f0ca617e764bac74b.jpg";